import React from 'react'
import '../../graphStyles.scss'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2'
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )




/**
 * Made up data to be replaced
 */
const labels = [
    'Age (45-64)',
    'Gender (Female)',
    'State (TX, WA)',
    'Device (IOS)',
    'Day of Week (Sun)',
    'Time of Day (afternoon)',
    'Word Group 1 (Environmentall Friendly)',
    'Word Group 2 (Traditional Razor)',
    'Word Group 3 (Platinum Coated)',
    'Word Group 4 (Super Saver Pack)'
]

const fakeAddToCart = [
    [10], 
    [null, 18], 
    [null, null, 25], 
    [null, null, null, 35], 
    [null, null, null, null, 42],
    [null, null, null, null, null, 50], 
    [null, null, null, null, null, null, 58], 
    [null, null, null, null, null, null, null, 42], 
    [null, null, null, null, null, null, null, null, 35], 
    [null, null, null, null, null, null, null, null, null, 25]
]






export function TopFeaturesAddToCartGraph({ features, addToCart }) {

  // Uncomment and delete above labels array
  //const labels = features


  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
            filter: (l) => (l.text === 'Add to Cart')
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart13").style.cursor = 'pointer';
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart13").style.cursor = 'default';
        },
      },

    },
    scales: {
        x: {
            title: {
                display: true,
                text: 'List of Features',
                font: {
                    size: 13.5
                }
            },
            stacked: true,
            grid: {
                display: false
            },
            
        },
        y: {
            title: {
              display: true,
              text: 'Number of Added to Cart',
              font: {
                size: 13.5
              }
            }
        },   
    },
  }



  const data = {

    // Replace with weeks prop
    labels,

    datasets: [
      {
        label: 'Add to Cart',

        // Replace with clicks prop
        // Teal
        data: fakeAddToCart[0],
        backgroundColor: 'rgba(13, 155, 98)',

      },
      {
        // Red
        data: fakeAddToCart[1],
        backgroundColor: 'rgba(200, 35, 60)',

      },
      {
        // Light blue
        data: fakeAddToCart[2],
        backgroundColor: 'rgba(0, 200, 248)',
      },
      {
        // Yellow
        data: fakeAddToCart[3],
        backgroundColor: 'rgba(250, 196, 60)',
      },
      {
        // Orange
        data: fakeAddToCart[4],
        backgroundColor: 'rgba(209, 150, 98)',
      },
      {
        // Dark Blue
        data: fakeAddToCart[5],
        backgroundColor: 'rgba(32, 43, 165, 1)'
      },
      {
        // Pink
        data: fakeAddToCart[6],
        backgroundColor: 'rgba(255, 188, 207, 1)'
      },
      {
        // Blue
        data: fakeAddToCart[7],
        backgroundColor: 'rgba(150, 136, 255, 1)'
      },
      {
        // Green
        data: fakeAddToCart[8],
        backgroundColor: 'rgba(88, 204, 108, 1)'
      },
      {
        // Purple
        data: fakeAddToCart[9],
        backgroundColor: 'rgba(175, 100, 184, 1)'
      },
      
    ],
  }



    return (
        <div className='graph'>
            <div className='graph__title'>
                <h4>Top Important Features Based On Add to Cart</h4>
            </div>
            <Bar className='chart' id='chart13' options={options} data={data}/>
        </div>
    )
}
